import { render, staticRenderFns } from "./depot1.vue?vue&type=template&id=17454e1e&scoped=true&"
import script from "./depot1.vue?vue&type=script&lang=js&"
export * from "./depot1.vue?vue&type=script&lang=js&"
import style0 from "./depot1.vue?vue&type=style&index=0&id=17454e1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17454e1e",
  null
  
)

export default component.exports